import { FC } from 'react';
import { get } from 'lodash';
import { injectIntl, IntlShape } from 'react-intl';
import Document from 'components/Document';
import { BlobProvider } from '@react-pdf/renderer';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DesignationLetter from 'components/DesignationLetter/DesignationLetter';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerAssignedExpertise/messages';
import {
  InputWrapper,
  InputWithoutPaddingWrapper,
} from 'containers/CourtManagerAssignedExpertise/style';
import { getCity } from 'containers/RecapManagerPage/utils';
import { isTransactionMission } from 'containers/CourtManagerAssignedExpertise/utils';
import DesignationLetterTransaction from 'components/DesignationLetter/DesignationLetterTransaction';

interface TextElementProps {
  intl: IntlShape;
  listings: any;
  mission: any;
  withoutPadding?: boolean;
}

const LetterDesignation: FC<TextElementProps> = props => {
  const getExpertInfo = (expertCode: any) => {
    const expertInfo = get(props.listings, 'intervenants')?.find(
      (item: any) => Number(item.ItemKey) === Number(expertCode),
    );
    const expertTown =
      expertInfo?.townCode &&
      getCity(get(props.listings, 'villes', []), expertInfo?.townCode as any);
    return {
      ...expertInfo,
      expertTown: expertTown?.ItemDescription,
    };
  };
  return (
    <>
      <h3 style={{ padding: props.withoutPadding ? 'unset' : '0px 24px' }}>
        {translate(messages.designationLetter, props)}
      </h3>

      {props.mission.assignedExpert.map((item: any) =>
        props.withoutPadding ? (
          <InputWithoutPaddingWrapper>
            <Document
              name={
                translate(messages.designationLetter, props) +
                ' ( ' +
                getExpertInfo(item.expertCode)?.ItemDescription +
                ' )'
              }
              type={translate(messages.designationLetter, props)}
              icon={
                <BlobProvider
                  document={
                    (isTransactionMission(props.mission) ? (
                      <DesignationLetterTransaction
                        data={{
                          ...props.mission,
                          victim:
                            get(props.mission, 'victims.[0].firstName', '') +
                            ' ' +
                            get(props.mission, 'victims.[0].lastName', ''),
                          reference: props.mission?.missionNumber,
                          expertInfo: getExpertInfo(item.expertCode),
                        }}
                      />
                    ) : (
                      <DesignationLetter
                        data={{
                          ...props.mission,
                          reference: props.mission?.missionNumber,
                          expertInfo: getExpertInfo(item.expertCode),
                        }}
                      />
                    )) as any
                  }
                >
                  {params => {
                    return (
                      <a
                        href={params.url ? params.url : ''}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <VisibilityIcon
                          style={{ color: 'black' }}
                          className="consult"
                        />
                      </a>
                    );
                  }}
                </BlobProvider>
              }
            />
          </InputWithoutPaddingWrapper>
        ) : (
          <InputWrapper>
            <Document
              name={
                translate(messages.designationLetter, props) +
                ' ( ' +
                getExpertInfo(item.expertCode)?.ItemDescription +
                ' )'
              }
              type={translate(messages.designationLetter, props)}
              icon={
                <BlobProvider
                  document={
                    (isTransactionMission(props.mission) ? (
                      <DesignationLetterTransaction
                        data={{
                          ...props.mission,
                          victim:
                            get(props.mission, 'victims.[0].firstName', '') +
                            ' ' +
                            get(props.mission, 'victims.[0].lastName', ''),
                          reference: props.mission?.missionNumber,
                          expertInfo: getExpertInfo(item.expertCode),
                        }}
                      />
                    ) : (
                      <DesignationLetter
                        data={{
                          ...props.mission,
                          reference: props.mission?.missionNumber,
                          expertInfo: getExpertInfo(item.expertCode),
                        }}
                      />
                    )) as any
                  }
                >
                  {params => {
                    return (
                      <a
                        href={params.url ? params.url : ''}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <VisibilityIcon
                          style={{ color: 'black' }}
                          className="consult"
                        />
                      </a>
                    );
                  }}
                </BlobProvider>
              }
            />
          </InputWrapper>
        ),
      )}
    </>
  );
};

export default injectIntl(LetterDesignation);
